import { useTranslation } from 'react-i18next';
import SETTING_KEYS from '../../constants/setting-keys';
import Button, { ButtonType } from '../general-components/Button';
import RichText from '../general-components/RichText';
import SelectItem from '../general-components/SelectItem';
import CloseIcon from '@mui/icons-material/Close';

import styles from './CustomFields.module.css';

const CustomFields = ({
    customFields,
    onAddField,
    onUpdateField,
    onDeleteField,
}: {
    customFields: any;
    onAddField: Function;
    onUpdateField: Function;
    onDeleteField: Function;
}) => {
    const { t } = useTranslation();

    const renderCustomFields = (field: any, index: number) => {
        return (
            <div key={index} className={styles.customFieldContainer}>
                <div className={styles.fieldInputContainer}>
                    <SelectItem
                        checked={field.isCritical}
                        type="checkbox"
                        labelled={true}
                        value={t('customFields.field.criticalInfo')}
                        onChange={() =>
                            onUpdateField(index, {
                                ...field,
                                isCritical: !field.isCritical,
                            })
                        }
                    />
                    <input
                        type="text"
                        className={styles.fieldInput}
                        placeholder={t('customFields.field.titlePlaceholder')}
                        value={field.heading}
                        onChange={(e) =>
                            onUpdateField(index, {
                                ...field,
                                heading: e.target.value,
                            })
                        }
                    />
                    <RichText
                        description={field.value}
                        onChange={(richText) =>
                            onUpdateField(index, { ...field, value: richText })
                        }
                    />
                </div>
                <Button
                    type={ButtonType.cancel}
                    onClick={() => onDeleteField(index)}
                >
                    <CloseIcon />
                </Button>
            </div>
        );
    };

    return (
        <>
            <h3>{t('customFields.title')}</h3>
            <div className={styles.customFields}>
                {customFields && customFields.map(renderCustomFields)}
            </div>
            <Button
                type={ButtonType.primary}
                onClick={onAddField}
                className={styles.customBtn}
            >
                {t('customFields.addButton')}
            </Button>
        </>
    );
};

export default CustomFields;
